import React, { useRef, useState, useEffect } from "react"

import styles from "../styles/inspire.module.css"

const data = [
  {
    key: 0,
    title: "How I Tricked My Brain To Like Doing Hard Things",
    url: "https://www.youtube.com/watch?v=9QiE-M1LrZk",
  },
  {
    key: 1,
    title: "The Strangest Secret - Earl Nightingale",
    url: "https://www.youtube.com/watch?v=IeaBfM3TdHQ",
  },

]

export default function Inspiration() {
  const [inView, setInView] = useState(false)
  const ref = useRef()
  useEffect(() => {
    var rect =
      ref?.current?.getBoundingClientRect().top - window.innerHeight + 100
    window.addEventListener("scroll", () => {
      setInView(window.scrollY > rect)
    })
  }, [])

  const bgClassName = inView ? styles.inView : styles.outView
  return (
    <div className={styles.container}>
      <h1 className={styles.title}>Inspiration</h1>
      <div className={[styles.row, bgClassName].join(" ")} ref={ref}>
        <div className={[styles.content].join(" ")}>
          <div className={styles.card}>
            <div className={styles.header}>
              <h4>{data[0].title}</h4>
              <a href={data[0].url}>{data[0].url}</a>
            </div>
          </div>
        </div>
        <div className={[styles.content, styles.right].join(" ")}>
          <div className={styles.card}>
            <div className={styles.header}>
              <h4>{data[1].title}</h4>
              <a href={data[1].url}>{data[1].url}</a>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
